import "./WhyLanding.scss";
import ArrowBtn from "../../../components/arrowbtn/ArrowBtn";
import { baseUrl } from "../../../utils/apiData";

const WhyLanding = ({title, des, img}) => {
  return (
    <section className="why_landing">
      <div className="content_wrap p_top p_bottom">
        <div className="text_content">
            <h1 className="wow fadeInUp">{title}</h1>
            <p className="wow fadeInUp" data-wow-delay="0.1s">{des}</p>
            <ArrowBtn 
                text="Get in touch"
                theme="secondary_ternery"
                classList="wow fadeInUp"
            />
        </div>
        <div className="img_wrap">
          <img src={`${baseUrl}/${img}`} alt="img" />
        </div>
      </div>
    </section>
  );
};

export default WhyLanding;
